import TrackingStats from "../../components/Pages/Tracking/Stats/Stats";

const TrackingStatsPage = () => {
  return (
    <div>
      <TrackingStats />
    </div>
  );
};

export default TrackingStatsPage;
